import { render, staticRenderFns } from "./DepartureTabs.vue?vue&type=template&id=4bf94842&"
import script from "./DepartureTabs.vue?vue&type=script&lang=js&"
export * from "./DepartureTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports